import { ITransaction } from "store/fetchers/users/types"

export const getUpdatedTxsArray = (newTxs: ITransaction[], oldTxs: ITransaction[]) => {
  try {
    const txKeys = new Set(
      newTxs?.map(tx => `${tx.account_type}_${tx.account_id}`) ?? []
    )

    const merged = [
      ...newTxs,
      ...oldTxs.filter(tx => !txKeys.has(`${tx.account_type}_${tx.account_id}`))
    ]

    return merged
  } catch (error) {
    return newTxs ?? []
  }
}